import { ClaimType } from '../store/navigation.type';

export const disableBuildingAndContent = (claimCategoy: ClaimType) => {
  if (claimCategoy === 'CLAIMS_BUILDING' || claimCategoy === 'CLAIMS_CONTENT') {
    const today = new Date().toISOString().split('T')[0];
    const unavailableDates = ['2024-01-26'];

    return unavailableDates.includes(today);
  }
  return false;
};
